import React, { useEffect } from "react";
import PInformation from "../../../img/Glenmark-Fenhuma-PI-Sep-2024_V0.4_page-0001.jpg";

export default function PI() {
  useEffect(() => {
    document.title = "Fenhuma® - Prescribing Information";
  }, []);
  return (
    <main>
      <section className="section section--grey section--full-width section--report">
        <div className="inner-container">
          <img src={PInformation} alt="Prescribing Information" />
        </div>
      </section>
    </main>
  );
}
